<template>
  <div class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-[300] w-full inset-0 md:h-full transition transition-all opacity-100" id="partnerModal" tabindex="-1" aria-hidden="false" style="display: block; z-index: 8000;">
    <div class="bg-td-black-100 fixed z-0 top-0 left-0 w-screen h-screen bg-opacity-40 pointer-events-none"></div>
    
      <div class="modal-dialog checkout__modal__dialog relative p-4 top-24 bg-white md:h-auto mx-auto z-10 w-11/12 lg:w-4/5 max-w-[1200px] overflow-hidden shadow-md rounded-lg" v-if="partner !== null">
        <div class="modal-content checkout__modal__content p-0">
          <div class="modal-header checkout__modal__header relative rounded-md bg-transparent overflow-hidden p-4 lg:p-16 flex flex-row justify-content-start">
            <div class="checkout__modal__header__background absolute inset-0 w-full h-[210px] bg-td-orange-100 z-0">
            </div>
            <div class="checkout__modal__header__picture relative w-24 h-24 rounded-full z-10 bg-white mr-4 lg:mr-10 overflow-hidden">
              <img class="w-full h-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" :src="`${bedrijfslogo.url}`" :alt="`${bedrijfslogo.alt}`" :title="`${bedrijfslogo.title}`"  />
            </div>
            <div class="checkout__modal__header__name flex flex-col justify-content-start text-start z-10">
              <h5 class="text-white font-bold text-lg lg:text-2xl mt-3 mb-0">{{ partner.acf.bedrijfsgegevens.bedrijfsnaam }}.</h5>
              <span class="text-base text-white">{{ partner.acf.bedrijfsgegevens.plaats }}</span>
            </div>
            <button @click="$emit('closeModal')" type="button" class="btn-close checkout__modal__header__close z-10" data-bs-dismiss="modal" aria-label="Close"></button>
            
          </div>
          <div class="checkout__modal__body flex flex-col flex-wrap p-8 lg:py-16 lg:px-[15%]">
            <div class="checkout__modal__body__about w-full flex-grow text-center font-bold hidden lg:block" v-html="partner.acf.bedrijfsinformatie.biografie">
            
            </div>
            <div class="checkout__modal__body__content flex flex-col lg:flex-row justify-center">  
              <div class="checkout__modal__body__left flex flex-col lg:flex-row lg:mt-5">
                <div class="checkout__modal__body__left__profilepic hidden lg:flex border-sm overflow-hidden self-start items-start">
                  <img class="max-w-[150px] lg:max-w-none" :src="`${profielfoto}`" :alt="`${partner.acf.medewerkers.profielfoto.alt}`" :title="`${partner.acf.medewerkers.profielfoto.title}`" width="200" height="auto"  />
                </div>
                <div class="checkout__modal__body__left__details flex flex-col pl-0 lg:pl-5">
                  <strong class="hidden lg:block">Contactpersoon</strong>
                  <span class="mb-2 hidden lg:block">{{ `${partner.acf.medewerkers.voornaam} ${partner.acf.medewerkers.achternaam} ` }} </span>
                  <strong>Aantal FTE's</strong>
                  <span class="mb-2">{{ `${partner.acf.medewerkers.ftes}` }} </span>

                  <div>
                    <strong>Waardering op Google</strong>
                    <div class="flex flex-row mb-2" v-html="getStars"></div>
                    <div class="text-xs opacity-70">
                      {{ `(${getAverageScore} gemiddeld uit ${getVoteQuanity} stemmen) `}}
                    </div>
                </div>
                </div>
              </div>

              <div class="checkout__model__body__right mt-4 lg:pl-5 lg:mt-5">
                <strong>Gespecialiseerd in</strong>
                <ul class="widget__usps__list w-full">
                  <li v-for="(specialisatie, index) in partner.acf.bedrijfsinformatie.specialisaties" :key="index" class="lg:mr-6 pl-8 relative text-td-black-100 last:mr-0 before:absolute before:left-0 before:w-4 before:h-4 before:top-2 before:content-[''] before:bg-image before:bg-[url('./dist/img/ic_checkmark_green.svg')] before:bg-no-repeat before:bg-center before:bg-contain" :data-usp="specialisatie.value">
                    {{ specialisatie.label }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="checkout__modal__footer p-5 pt-0 flex flex-col lg:flex-row lg:justify-between">

            <div @click="$emit('closeModal')" class="close__model w-full lg:w-auto">
              <strong class="block btn btn-white w-full hover:cursor-pointer">Sluiten</strong>
            </div>

            <a class="btn btn-light w-full lg:w-auto lg:ml-auto mt-3 lg:mt-0" title="Ga naar het uitgebreide profiel van Succesfactor" :href="partner.slug">
              Uitgebreid profiel bekijken
            </a>
            
            <a @click="$emit('choosePartner', partner)" href="#" class="btn btn-green w-full lg:w-auto mt-3 lg:ml-3 lg:mt-0" title="Kiezen als aanbieder">
              Kies als aanbieder
            </a>

          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    partner: {
      type: Object,
      required: false,
      default: () => { },
    },
  },
  computed: {
    bedrijfslogo() {
      let logo = {
        url: '',
        alt: '',
        title: ''
      }
      if (this.partner !== {}) {
        logo.url = this.partner.acf.bedrijfsinformatie.bedrijfslogo.url;
        logo.alt = this.partner.acf.bedrijfsinformatie.bedrijfslogo.alt;
        logo.title = this.partner.acf.bedrijfsinformatie.bedrijfslogo.title;
      }
      return logo
    },
    profielfoto() {
      let foto = '/wp-content/themes/teachdigital/dist/img/empty_profilepic.svg';
      if (this.partner.hasOwnProperty('acf')) {
        if (this.partner.acf.hasOwnProperty('medewerkers')) {
          if (this.partner.acf.medewerkers.hasOwnProperty('profielfoto')) {
            if (this.partner.acf.medewerkers.profielfoto.url !== undefined && this.partner.acf.medewerkers.profielfoto.url !== '') {
              foto = this.partner.acf.medewerkers.profielfoto.url
            }
          } 
        }
      }
      return foto;
    },
    getStars() {
      let output = '';
      if (this.partner.hasOwnProperty('acf')) {
        if (this.partner.acf.hasOwnProperty('google')) {
          if (this.partner.acf.google.gemiddeld !== '') {
            const stars = Number(this.partner.acf.google.gemiddeld);

            console.log(stars);

            if (stars !== '' && stars > 0) {
              for (let i = 0; i < Math.floor(stars); i++) {
                output += '<img src="/wp-content/themes/teachdigital/dist/img/ic_star_filled.svg" alt="Ster" width="" height="" />';
              }
              if (stars !== 5) {


                if (stars % 1 !== 0) {


                  output += '<img src="/wp-content/themes/teachdigital/dist/img/ic_star_half.svg" alt="Ster" width="" height="" />';

                  let starsFloor = Math.round(stars);
                  let emptyStarsQty = 5 - starsFloor;

                  for (let k = 0; k < emptyStarsQty; k++) {
                    output += '<img src="/wp-content/themes/teachdigital/dist/img/ic_star_empty.svg" alt="Ster" width="" height="" />';
                  }

                } else {
                  let emptyStarsQty = 5 - Math.floor(stars);
                  for (k = 0; k < emptyStarsQty; k++) {
                    output += '<img src="/wp-content/themes/teachdigital/dist/img/ic_star_empty.svg" alt="Ster" width="" height="" />';
                  }
                }



              }
            }
          }
        }
      }
      return output;
    },
    getVoteQuanity() {
      let output = '';
      if (this.partner.hasOwnProperty('acf')) {
        if (this.partner.acf.hasOwnProperty('google')) {
          if (this.partner.acf.google.stemmen !== '') {
            output = this.partner.acf.google.stemmen;
          }
        }
      }
      return output;
    },
    getAverageScore() {
      let output = '';
      if (this.partner.hasOwnProperty('acf')) {
        if (this.partner.acf.hasOwnProperty('google')) {
          if (this.partner.acf.google.gemiddeld !== '') {
            output = this.partner.acf.google.gemiddeld;
          }
        }
      }
      return output;
    }
  }
}
</script>